import { render, staticRenderFns } from "./ClockRemovalCard.vue?vue&type=template&id=819bec78&"
import script from "./ClockRemovalCard.vue?vue&type=script&lang=js&"
export * from "./ClockRemovalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports